import { Analysis, AnalysisFormData, BackgroundAnalysisOptions } from '../types';
import { performBackgroundAnalysis } from './backgroundAnalysisService';

export async function analyzeWithAI(
  data: AnalysisFormData,
  options?: BackgroundAnalysisOptions,
  abortSignal?: AbortSignal
): Promise<Analysis> {
  // Всегда используем фоновый анализ
  console.log('🔍 aiService - Используем фоновый анализ');
  console.log('🔍 aiService - Передаем данные:', data);
  return await performBackgroundAnalysis(
    {
      description: data.description,
      url: data.url,
      expert: data.expert,
      person: data.person,
      landing: data.landing,
      question: data.question,
      noQuestion: data.noQuestion
    },
    options,
    abortSignal
  );
}

 